import * as React from 'react';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import BtnFilled from '../components/BtnOutlined';
import HtmlEditor from '../components/HtmlEditor';
import HtmlViewer from '../components/HtmlViewer';
import { getInstructionsApi2, addInstructionApi2, editInstructionApi2, getPermitApi2 } from '../api/api2';
import { toast } from 'react-toastify';
import Modal from '../components/Modal';
import Input from '../components/Input';
import FileUploader from '../components/FileUploaderBody';
import { Contacts } from '../features/Support/components';

const Support = () => {
  const tabActiveStyle = (index, length) => {
    let style =
      'inline-block p-1 pt-4 w-full text-base text-gray-800 border-t border-x border-gray-300 bg-white font-bold active cursor-pointer select-none truncate';
    if (index === 0) {
      style += ' rounded-t-3xl';
    } else if (index === length - 1) {
      style += ' rounded-tr-3xl';
    }
    return style;
  };

  const tabInactiveStyle =
    'inline-block p-1 w-full text-base bg-opacity-0 border-b border-gray-300 text-gray-600 hover:text-gray-800 font-bold cursor-pointer select-none truncate';
  const [tabs, setTabs] = React.useState([{ name: 'Контакты', active: true }]);

  const [editPermit, setEditPermit] = React.useState(false);
  const [preview, setPreview] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [instructions, setInstructions] = React.useState([]);
  const [instToAdd, setInstToAdd] = React.useState({ type: 'htmljs' });
  const [instToShow, setInstToShow] = React.useState({});

  const makeActive = async (index) => {
    setTabs([...tabs.map((tab, i) => ({ ...tab, active: index === i ? true : false }))]);
    if (index === 1) {
      await getInstructions();
    }
  };

  // React.useEffect(() => {
  //   const get = async () => {
  //     await getPermission();
  //   };
  //   get();
  // }, []);

  async function getPermission() {
    await getPermitApi2(
      function (data) {
        if (data?.edit === 'ok') {
          setEditPermit(true);
          setTabs([...tabs, { name: 'Загрузчик' }]);
        }
      },
      function (err) {
        setEditPermit(false);
      }
    );
  }

  async function getInstructions() {
    await getInstructionsApi2(
      function (data) {
        setInstructions(data);
        //setRefreshing(false);
      },
      function (err) {
        //setRefreshing(false);
        toast.error(err.error ? err.error : 'Ошибка сервера', { hideProgressBar: false });
      }
    );
  }

  async function addInstruction() {
    await addInstructionApi2(
      instToAdd,
      async function (data) {
        setShowAddModal(false);
        await getInstructions();
        //setRefreshing(false);
      },
      function (err) {
        //setRefreshing(false);
        toast.error(err.error ? err.error : 'Ошибка сервера', { hideProgressBar: false });
      }
    );
  }

  async function editInstruction() {
    await editInstructionApi2(
      instToShow,
      async function (data) {
        setShowModal(false);
        await getInstructions();
        //setRefreshing(false);
      },
      function (err) {
        //setRefreshing(false);
        toast.error(err.error ? err.error : 'Ошибка сервера', { hideProgressBar: false });
      }
    );
  }

  const add = async () => {
    setShowAddModal(true);
  };

  return (
    <div className="flex w-full min-h-screen p-4 items-start justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
      <div className="w-full max-w-sm sm:max-w-sm md:max-w-xl lg:max-w-2xl xl:max-w-4xl 2xl:max-w-4xl">
        <div className="rounded-lg m-2">
          <div className="text-sm font-medium text-center text-gray-500  dark:text-gray-400 dark:border-gray-700">
            <ul className="flex flex-nowrap">
              {tabs.map((tab, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      makeActive(index);
                    }}
                    className={tab.active ? tabActiveStyle(index, tabs.length) : tabInactiveStyle}>
                    {tab.name}
                  </li>
                );
              })}
            </ul>
          </div>
          {tabs[0]?.active && <Contacts />}
          {tabs[1]?.active && (
            <>
              <div className="w-full max-w-sm sm:max-w-sm md:max-w-xl lg:max-w-2xl xl:max-w-4xl 2xl:max-w-5xl">
                <form className="bg-white shadow-2xl rounded-b-3xl border-b border-x border-gray-300 px-8 pt-6 pb-8 mb-4">
                  {instructions.length !== 0 && (
                    <>
                      {instructions.map((inst, index) => {
                        return (
                          <>
                            <div
                              className="grid grid-cols-12 gap-4 items-center justify-items-center border-b p-2 hover:bg-gray-100 hover:cursor-pointer"
                              onClick={() => (setInstToShow(inst), setShowModal(true))}>
                              {/* <div className="col-span-1">
                                  <SettingsIcon className="w-6 sm:w-6 xl:w-8 2xl:w-8 h-6 sm:h-6 xl:h-8 2xl:h-8 fill-orange-500"></SettingsIcon>
                                </div>*/}
                              <div className="col-span-11 justify-self-start">
                                <p className="select-none text-wrap">{inst?.title}</p>
                                <p className="text-xs text-wrap select-none">{inst?.descr}</p>
                              </div>

                              {/*<div className="col-span-1">
                                  <ModeEditOutlineOutlinedIcon className="w-6 sm:w-6 xl:w-8 2xl:w-8 h-6 sm:h-6 xl:h-8 2xl:h-8 fill-gray-900 hover:fill-orange-500"></ModeEditOutlineOutlinedIcon>
                                </div>*/}

                              <div className="col-span-1">
                                <KeyboardDoubleArrowRightIcon className="w-6 sm:w-6 xl:w-8 2xl:w-8 h-6 sm:h-6 xl:h-8 2xl:h-8 fill-gray-900 hover:fill-orange-500 animate-pulse"></KeyboardDoubleArrowRightIcon>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </>
                  )}
                  {editPermit && (
                    <div className="w-full mb-0 mt-8">
                      <BtnFilled title="Добавить" btnCb={() => add()}></BtnFilled>
                    </div>
                  )}
                </form>
              </div>
              <Modal
                showModal={showAddModal}
                setShowModal={setShowAddModal}
                saveCb={() => addInstruction()}
                closeCb={() => getInstructions()}
                title="Добавление инструкции"
                error={null}>
                <Input
                  classContainer={'w-full'}
                  value={instToAdd.title}
                  inputCb={(e) => setInstToAdd({ ...instToAdd, title: e.target.value })}
                  label="Заголовок"
                  id="title"
                  type="text"
                  placeholder={'Подключение к WiFi'}></Input>
                <Input
                  classContainer={'w-full mt-4'}
                  value={instToAdd.descr}
                  inputCb={(e) => setInstToAdd({ ...instToAdd, descr: e.target.value })}
                  label="Описание"
                  id="descr"
                  type="text"
                  placeholder={'Здесь вы найдете инструкцию о том как подключить контроллер к WiFi роутеру'}></Input>
              </Modal>

              <Modal
                showModal={showModal}
                setShowModal={setShowModal}
                saveCb={() => editInstruction()}
                closeCb={() => getInstructions()}
                title={instToShow?.title}
                showSave={editPermit}
                error={null}
                classWidth="relative w-11/12 lg:w-1/2 my-6 mx-2">
                {editPermit ? (
                  <>
                    {preview ? <HtmlViewer html={instToShow}></HtmlViewer> : <HtmlEditor html={instToShow} setHtml={setInstToShow}></HtmlEditor>}
                    <div className="w-full mb-0 mt-8">
                      <BtnFilled title={preview ? 'Редактор' : 'Предпросмотр'} btnCb={() => setPreview((p) => !p)}></BtnFilled>
                    </div>
                  </>
                ) : (
                  <HtmlViewer html={instToShow} />
                )}
              </Modal>
            </>
          )}

          {tabs[2]?.active && editPermit && (
            <>
              <div className="w-full max-w-sm sm:max-w-sm md:max-w-xl lg:max-w-2xl xl:max-w-4xl 2xl:max-w-5xl">
                <form className="bg-white shadow-2xl rounded-b-3xl border-b border-x border-gray-300 px-8 pt-6 pb-8 mb-4">
                  <FileUploader />
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Support;
